export default [{
  path: '/comparativo-bdgd-ais',
  component: () => import('@/views/Index'),
  children: [
    {
      name: 'SIG-R Compara Histórico',
      path: 'historico',
      component: () => import('@/views/sigRCompara/Historico.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'SIG-R Compara' }
        ]
      }
    },
    {
      name: 'SIG-R Compara Adicionar',
      path: 'edit',
      component: () => import('@/views/sigRCompara/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups' },
          { name: 'SIG-R Compara', path: '/comparativo-bdgd-ais/historico' },
          { name: 'Adicionar' }
        ]
      }
    },
    {
      name: 'SIG-R Compara Editar',
      path: 'edit/:id',
      component: () => import('@/views/sigRCompara/Edit.vue'),
      meta: {
        requiresAuth: true,
        breadcrumb: [
          { name: 'Power Ups', path: '/powerups'},
          { name: 'SIG-R Compara', path: '/comparativo-bdgd-ais/historico' },
          { name: 'Editar' }
        ]
      }
    }
  ]
}]